module.exports = __webpack_public_path__ + "static/Monsieur-Saucisse.f4f02259.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Monsieur-Saucisse.jpg
// module id = 463
// module chunks = 35783957827783